var _defs, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _ellipse10, _ellipse11, _ellipse12, _ellipse13, _ellipse14, _ellipse15, _ellipse16, _ellipse17, _ellipse18, _ellipse19, _ellipse20, _ellipse21, _ellipse22, _ellipse23, _ellipse24, _ellipse25, _ellipse26, _ellipse27, _ellipse28, _ellipse29, _ellipse30, _ellipse31, _ellipse32, _ellipse33, _ellipse34, _ellipse35, _ellipse36, _ellipse37, _ellipse38, _ellipse39, _ellipse40, _ellipse41, _ellipse42, _ellipse43, _ellipse44, _ellipse45, _ellipse46, _ellipse47, _ellipse48, _ellipse49, _ellipse50, _ellipse51, _ellipse52, _ellipse53, _ellipse54, _ellipse55, _ellipse56, _ellipse57, _ellipse58, _ellipse59, _ellipse60, _ellipse61, _ellipse62, _ellipse63, _ellipse64, _ellipse65;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1450 1450",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#2e539c;}"))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 611.21,
    cy: 104.24,
    rx: 14.4,
    ry: 14.37
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 533.65,
    cy: 210.35,
    rx: 20.01,
    ry: 19.97
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 745.22,
    cy: 179.51,
    rx: 20.01,
    ry: 19.97
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 939.94,
    cy: 233.76,
    rx: 20.01,
    ry: 19.97
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 1109.15,
    cy: 345.84,
    rx: 20.01,
    ry: 19.97
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 1249.42,
    cy: 725.27,
    rx: 20.01,
    ry: 19.97
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 1222.45,
    cy: 523.46,
    rx: 20.01,
    ry: 19.97
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 1221.95,
    cy: 926.92,
    rx: 20.01,
    ry: 19.97
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 1108.66,
    cy: 1105.58,
    rx: 20.01,
    ry: 19.97
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 940.43,
    cy: 1217.51,
    rx: 20.01,
    ry: 19.97
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 745.22,
    cy: 1272.82,
    rx: 20.01,
    ry: 19.97
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 534.32,
    cy: 1241.99,
    rx: 20.01,
    ry: 19.97
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 356.78,
    cy: 1134.31,
    rx: 20.01,
    ry: 19.97
  })), _ellipse14 || (_ellipse14 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 240.8,
    cy: 963.98,
    rx: 20.01,
    ry: 19.97
  })), _ellipse15 || (_ellipse15 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 188.32,
    cy: 765.75,
    rx: 20.01,
    ry: 19.97
  })), _ellipse16 || (_ellipse16 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 188.32,
    cy: 685.48,
    rx: 20.01,
    ry: 19.97
  })), _ellipse17 || (_ellipse17 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 241.29,
    cy: 486.76,
    rx: 20.01,
    ry: 19.97
  })), _ellipse18 || (_ellipse18 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 357.53,
    cy: 316.92,
    rx: 20.01,
    ry: 19.97
  })), _ellipse19 || (_ellipse19 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 476.78,
    cy: 349.65,
    rx: 26.95,
    ry: 26.89
  })), _ellipse20 || (_ellipse20 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 640.1,
    cy: 287.49,
    rx: 26.95,
    ry: 26.89
  })), _ellipse21 || (_ellipse21 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 806.37,
    cy: 294.83,
    rx: 26.95,
    ry: 26.89
  })), _ellipse22 || (_ellipse22 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 962.34,
    cy: 352.76,
    rx: 26.95,
    ry: 26.89
  })), _ellipse23 || (_ellipse23 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 1086.43,
    cy: 476.59,
    rx: 26.95,
    ry: 26.89
  })), _ellipse24 || (_ellipse24 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 1144.79,
    cy: 633.71,
    rx: 26.95,
    ry: 26.89
  })), _ellipse25 || (_ellipse25 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 1144.79,
    cy: 816.26,
    rx: 26.95,
    ry: 26.89
  })), _ellipse26 || (_ellipse26 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 1085.2,
    cy: 973.79,
    rx: 26.95,
    ry: 26.89
  })), _ellipse27 || (_ellipse27 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 961.16,
    cy: 1095.2,
    rx: 26.95,
    ry: 26.89
  })), _ellipse28 || (_ellipse28 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 806.37,
    cy: 1155.53,
    rx: 26.95,
    ry: 26.89
  })), _ellipse29 || (_ellipse29 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 639.85,
    cy: 1162.96,
    rx: 26.95,
    ry: 26.89
  })), _ellipse30 || (_ellipse30 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 476.81,
    cy: 1099.2,
    rx: 26.95,
    ry: 26.89
  })), _ellipse31 || (_ellipse31 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 354.12,
    cy: 980.16,
    rx: 26.95,
    ry: 26.89
  })), _ellipse32 || (_ellipse32 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 293.33,
    cy: 823.43,
    rx: 26.95,
    ry: 26.89
  })), _ellipse33 || (_ellipse33 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 293.33,
    cy: 626.52,
    rx: 26.95,
    ry: 26.89
  })), _ellipse34 || (_ellipse34 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 369.32,
    cy: 725.27,
    rx: 44.76,
    ry: 44.67
  })), _ellipse35 || (_ellipse35 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 388.54,
    cy: 592.02,
    rx: 44.76,
    ry: 44.67
  })), _ellipse36 || (_ellipse36 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 465.92,
    cy: 478.52,
    rx: 44.76,
    ry: 44.67
  })), _ellipse37 || (_ellipse37 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 578.41,
    cy: 406.94,
    rx: 44.76,
    ry: 44.67
  })), _ellipse38 || (_ellipse38 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 708.46,
    cy: 386.39,
    rx: 44.76,
    ry: 44.67
  })), _ellipse39 || (_ellipse39 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 839.56,
    cy: 406.94,
    rx: 44.76,
    ry: 44.67
  })), _ellipse40 || (_ellipse40 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 953.29,
    cy: 478.52,
    rx: 44.76,
    ry: 44.67
  })), _ellipse41 || (_ellipse41 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 1023.11,
    cy: 591.79,
    rx: 44.76,
    ry: 44.67
  })), _ellipse42 || (_ellipse42 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 1055.47,
    cy: 724.76,
    rx: 44.76,
    ry: 44.67
  })), _ellipse43 || (_ellipse43 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 1023.11,
    cy: 858.16,
    rx: 44.76,
    ry: 44.67
  })), _ellipse44 || (_ellipse44 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 952.81,
    cy: 968.91,
    rx: 44.76,
    ry: 44.67
  })), _ellipse45 || (_ellipse45 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 838.84,
    cy: 1045.35,
    rx: 44.76,
    ry: 44.67
  })), _ellipse46 || (_ellipse46 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 711.56,
    cy: 1063.48,
    rx: 44.76,
    ry: 44.67
  })), _ellipse47 || (_ellipse47 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 580.61,
    cy: 1042.2,
    rx: 44.76,
    ry: 44.67
  })), _ellipse48 || (_ellipse48 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 464.46,
    cy: 968.91,
    rx: 44.76,
    ry: 44.67
  })), _ellipse49 || (_ellipse49 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 388.54,
    cy: 859.76,
    rx: 44.76,
    ry: 44.67
  })), _ellipse50 || (_ellipse50 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 354.16,
    cy: 469.56,
    rx: 26.95,
    ry: 26.89
  })), _ellipse51 || (_ellipse51 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 387.71,
    cy: 192.14,
    rx: 14.4,
    ry: 14.37
  })), _ellipse52 || (_ellipse52 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 221.18,
    cy: 362.27,
    rx: 14.4,
    ry: 14.37
  })), _ellipse53 || (_ellipse53 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 119.24,
    cy: 578.45,
    rx: 14.4,
    ry: 14.37
  })), _ellipse54 || (_ellipse54 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 119.24,
    cy: 873.81,
    rx: 14.4,
    ry: 14.37
  })), _ellipse55 || (_ellipse55 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 220.78,
    cy: 1088.96,
    rx: 14.4,
    ry: 14.37
  })), _ellipse56 || (_ellipse56 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 387.7,
    cy: 1259.7,
    rx: 14.4,
    ry: 14.37
  })), _ellipse57 || (_ellipse57 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 610.94,
    cy: 1345.76,
    rx: 14.4,
    ry: 14.37
  })), _ellipse58 || (_ellipse58 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 857.14,
    cy: 1338.82,
    rx: 14.4,
    ry: 14.37
  })), _ellipse59 || (_ellipse59 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 1069.95,
    cy: 1237.49,
    rx: 14.4,
    ry: 14.37
  })), _ellipse60 || (_ellipse60 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 1236.87,
    cy: 1077.16,
    rx: 14.4,
    ry: 14.37
  })), _ellipse61 || (_ellipse61 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 1330.76,
    cy: 848.83,
    rx: 14.4,
    ry: 14.37
  })), _ellipse62 || (_ellipse62 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 1330.76,
    cy: 602.44,
    rx: 14.4,
    ry: 14.37
  })), _ellipse63 || (_ellipse63 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 1236.17,
    cy: 373.41,
    rx: 14.4,
    ry: 14.37
  })), _ellipse64 || (_ellipse64 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 1067.87,
    cy: 213.78,
    rx: 14.4,
    ry: 14.37
  })), _ellipse65 || (_ellipse65 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 856.44,
    cy: 112.45,
    rx: 14.4,
    ry: 14.37
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.6b2f70ffd0b03054cd229a2bd941ed37.svg";
export { ForwardRef as ReactComponent };